import { Injectable } from "@angular/core";
import { ConstructionCostUnits } from "src/app/core/v3/construction-costs/units";

@Injectable()
export class UnitService {
  private _options = ConstructionCostUnits

  getOptionFromSizeUnit(sizeUnitId: number): number {
    return unitAreaMeasurementToUnit(sizeUnitId)
  }

  getOptions() {
    return this._options
  }
}

export function unitAreaMeasurementToUnit(
  sizeUnitId: number
) {
  if (sizeUnitId == 1) return 2
  if (sizeUnitId == 2) return 3
  return 1
}

export function unitConversionBasedOnTpUnit(
  tpSizeUnitId: number,
  originalUnitId: number
): number {
  if ([1, 4, 5, 8, 9, 10, 11, 12, 13, 14, 15, 16, 15, 17].includes(originalUnitId)) return originalUnitId
  // Square Metre
  if (tpSizeUnitId == 1) {
    if (originalUnitId == 3) return 2
    if (originalUnitId == 18) return 6
    if (originalUnitId == 19) return 7
    return originalUnitId
  }

  // Square feet
  if (tpSizeUnitId == 2) {
    if (originalUnitId == 2) return 3
    if (originalUnitId == 6) return 18
    if (originalUnitId == 7) return 19
    return originalUnitId
  }

  return 1
}

export function unitRateConversionBasedOnUnit(
  value: number,
  initialUnit: number,
  targetPropertyUnit: number
): number {
  if (!value) return null

  // Imperial
  if (targetPropertyUnit == 2) {
    if (initialUnit == 2) return value / 10.7639
    if (initialUnit == 6) return value / 3.2808399
    if (initialUnit == 7) return value / 35.3146667
  }

  // Metric
  if (targetPropertyUnit == 1) {
    if (initialUnit == 3) return value / 0.092903
    if (initialUnit == 18) return value / 0.3048
    if (initialUnit == 19) return value / 0.028317
  }

  return value
}